import { Routes, Route } from 'react-router-dom';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import ProtectedAdmin from './components/ProtectedLayoutAdmin';
import AdminUsers from './AdminUsers';
import AdminTrans from './AdminTrans';
import AdminSupport from './AdminSupport';
import AdminSettings from './AdminSettings';

export default function AdminRoutes() {
  return (
    <Routes>
      <Route path="/" element={<AdminLogin />} />
      <Route element={<ProtectedAdmin />}>
        <Route path="/dashboard" element={<AdminDashboard />} />
        <Route path="/users" element={<AdminUsers />} />
        <Route path="/transactions" element={<AdminTrans />} />
        <Route path="/support" element={<AdminSupport />} />
        <Route path="/settings" element={<AdminSettings />} />
      </Route>
    </Routes>
  );
}